.CompletedTasks {
  :global(.card) {
    background-color: var(--bs-gray-300);
    text-decoration: line-through;
  }
}
